
import { createContext, useCallback, useMemo, useState }  from "react";
import { decodeToken } from "react-jwt";

import { MY_AUTH_APP, MY_AUTH_APP_TOKEN, MY_AUTH_APP_REFRESHTOKEN, SECONDS_TO_MILLISECONDS_COEFF } from "const/CommonConst";
import service from "services/userService";

export const AuthContext = createContext();

export default function AuthContextProvider({children}){
    const [isAuthenticate, setIsAuthenticate] = useState(window.localStorage.getItem(MY_AUTH_APP) ?? false);

    const login = useCallback( async  (userName, password) => { 
        try {
            const data = await service.authenticate(userName, password);
            let result = false

            if (data && data.accessToken && data.success)
            {
                window.localStorage.setItem(MY_AUTH_APP, true);
                window.localStorage.setItem(MY_AUTH_APP_TOKEN, data.accessToken);
                setIsAuthenticate(true);
                result = true
            }
            else{                
                setIsAuthenticate(false);
            }

            return result
          } catch (error) {
            console.log(error);
          }
    });
    const logout = useCallback(() => { 
        window.localStorage.removeItem(MY_AUTH_APP);
        window.localStorage.removeItem(MY_AUTH_APP_TOKEN);
        setIsAuthenticate(false);
    });
    
    const getCurrentUser = useCallback(() => { 
        const data = decodeToken(window.localStorage.getItem(MY_AUTH_APP_TOKEN) ?? '');
        if (data){
            return `${data.unique_name}`;
        }

        return ''
    });
    const getCurrentUserRol = useCallback(() => { 
        const data = decodeToken(window.localStorage.getItem(MY_AUTH_APP_TOKEN) ?? '');
        if (data){
            return `${data.role}\\${data.unique_name}`;
        }

        return ''
    });
    const hasAccess = useCallback((roles) => {
        if (roles.length === 0)
            return true

        const data = decodeToken(window.localStorage.getItem(MY_AUTH_APP_TOKEN) ?? '');
        if (data){
            return roles.includes(data.role);
        }

        return false
    });
    const getUserContext = useCallback(() => { 
        return decodeToken(window.localStorage.getItem(MY_AUTH_APP_TOKEN) ?? '');
    });
    const checkExpired = useCallback(async () => { 
        const date = (new Date()).getTime();
        const token = decodeToken(window.localStorage.getItem(MY_AUTH_APP_TOKEN) ?? '');

        if (token && token.exp)
        {
            const exp = (new Date(SECONDS_TO_MILLISECONDS_COEFF * token.exp)).getTime();
            
            let expired = date > exp;
            
            return expired;
        }

        return true;
    });

    const value = useMemo(() => ({    
        login,
        logout,
        getCurrentUser,
        getCurrentUserRol,
        hasAccess,
        getUserContext,
        checkExpired,
        isAuthenticate
     }), [isAuthenticate, login, checkExpired]);

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    ) 
}